import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path d=\"M0 0h18v18H0z\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.268.732A2.5 2.5 0 0 1 10 2.5a.5.5 0 0 0 .5.5H14a1 1 0 0 1 1 1v3.5a.5.5 0 0 0 .5.5 2.5 2.5 0 0 1 0 5 .5.5 0 0 0-.5.5V17a1 1 0 0 1-1 1h-3.5a.5.5 0 0 1-.5-.5 2.5 2.5 0 0 0-5 0 .5.5 0 0 1-.5.5H1a1 1 0 0 1-1-1v-3.5a.5.5 0 0 1 .5-.5 2.5 2.5 0 0 0 0-5 .5.5 0 0 1-.5-.5V4a1 1 0 0 1 1-1h3.5a.5.5 0 0 0 .5-.5A2.5 2.5 0 0 1 9.268.732Z\" fill=\"currentColor\"></path></g><defs><clipPath id=\"a\"><path d=\"M0 0h18v18H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }